import { PageTransfersAch } from './Ach';
import { ACH_IMPORTS } from './AchImports';
import { PageTransfersAdd } from './Add';
import { PageTransfersAdmin } from './Admin';
import { TRANSFER_APPROVALS } from './Approvals';
import { TRANSFER_BATCHES } from './Batches';
import { PageTransfersBook } from './Book';
import { PageTransfersCheck } from './Check';
import { PageTransfersCrypto } from './Crypto';
import { PageTransfersInternationalWire } from './InternationalWire';
import { PageTransfers } from './Overview';
import { PageTransfersRealtime } from './Realtime';
import { PageTransferTemplatesEdit } from './Templates/Edit';
import { PageTransferTemplatesOverview } from './Templates/Overview';
import { PageTransferTemplatesReview } from './Templates/Review';
import { PageTransfersWire } from './Wire';
import { default as PageTransfersWireDrawdown } from './WireDrawdown';

export const TRANSFERS = {
  Transfers: PageTransfers,
  TransfersAch: PageTransfersAch,
  TransfersAdd: PageTransfersAdd,
  TransfersAdmin: PageTransfersAdmin,
  TransfersCheck: PageTransfersCheck,
  TransfersCrypto: PageTransfersCrypto,
  TransfersRealtime: PageTransfersRealtime,
  TransferTemplatesOverview: PageTransferTemplatesOverview,
  TransferTemplatesEdit: PageTransferTemplatesEdit,
  TransferTemplatesReview: PageTransferTemplatesReview,
  TransfersWire: PageTransfersWire,
  TransfersWireDrawdown: PageTransfersWireDrawdown,
  TransfersBook: PageTransfersBook,
  TransfersInternationalWire: PageTransfersInternationalWire,
  ...TRANSFER_APPROVALS,
  ...TRANSFER_BATCHES,
  ...ACH_IMPORTS,
} as const;
